import { render, staticRenderFns } from "./Alpr.vue?vue&type=template&id=1895551a&scoped=true&"
import script from "./Alpr.vue?vue&type=script&lang=js&"
export * from "./Alpr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1895551a",
  null
  
)

export default component.exports